$mol_check_box $mol_check
	Icon $mol_icon_tick
